import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { queryKeys } from '../query-keys';

export function useSaveFestivalMutation() {
  const queryClient = useQueryClient();
  const setFestival = useFestivalWorkspaceStore((s) => s.setFestival);

  return useApiMutation(
    (festival) => '/admin/festival',
    'post',
    {},
    {
      onSuccess: (data, variables) => {
        if (data) {
          setFestival(data);
        }
        queryClient.invalidateQueries({ queryKey: queryKeys.festivals() });
        if (data?.festivalId != null) {
          queryClient.invalidateQueries({
            queryKey: queryKeys.festival(String(data.festivalId)),
          });
        }
        if (variables?._autosave) {
          NotificationManager.success('Changes Saved', '', 3000);
        } else {
          NotificationManager.success('Festival details saved', '', 3000);
        }
      },
      onError: () => {
        NotificationManager.error('Could not save festival details', '', 3000);
      },
    },
    (festival) => {
      const { _autosave: _ignored, ...body } = festival ?? {};
      return body;
    },
  );
}

export function useChangeFestivalStatusMutation() {
  const queryClient = useQueryClient();
  const setFestival = useFestivalWorkspaceStore((s) => s.setFestival);

  return useApiMutation(
    ({ festivalId, status }) => `/admin/festival/${festivalId}/${status}`,
    'put',
    {},
    {
      onSuccess: (data, variables) => {
        if (data) {
          setFestival(data);
        }
        queryClient.invalidateQueries({
          queryKey: queryKeys.festival(String(variables.festivalId)),
        });
        queryClient.invalidateQueries({ queryKey: queryKeys.festivals() });
        NotificationManager.success('Festival status updated', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Could not update festival status', '', 3000);
      },
    },
    () => ({}),
  );
}
